import React from 'react';
import Loader from './Loader';

const Exchanges = () => {
  return (
    <div>
      <Loader />
      <p>On building stage</p>
    </div>
  );
};

export default Exchanges;
